<template>
  <div class="card">
    <div class="name">
      {{ item.name }}
    </div>
    <div class="datetime">
      <div class="label">时间/日期：</div>
      <div class="value">{{ item.datetime }}</div>
    </div>
    <div class="scenario">
      <div class="label">情景：</div>
      <div class="value">{{ item.scenario }}</div>
    </div>
    <div class="thinking">
      <div class="label">自动化思维：</div>
      <div class="value">{{ item.thinking }}</div>
    </div>
    <div class="emotion">
      <div class="label">情绪和生理反应：</div>
      <div class="value">{{ item.emotion }}</div>
    </div>
    <div class="result">
      <div class="label">行为和/或结果：</div>
      <div class="value">{{ item.result }}</div>
    </div>

    <div class="datetime">
      <div class="label">报告生成时间：</div>
      <div class="value">{{ item.createtime | dateFormat("MM月DD日 HH:ss") }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      require: true,
    },
  },
};
</script>

<style scoped lang="scss">
.card {
  position: relative;
  padding: 22px;
  box-sizing: border-box;
  border-radius: 12px;
  background-color: rgba(237, 244, 252, 1);
  border: 1px solid rgba(163, 206, 255, 1);
  background-image: url("@/assets/images/automatedMindRecognition-icon.png");
  background-size: 84px 84px;
  background-position: 275px 12px;
  background-repeat: no-repeat;
}

.name {
  font-size: 18px;
  font-weight: 600;
  line-height: 23.87px;
  color: rgba(18, 18, 18, 1);
  text-align: left;
  margin-bottom: 8px;
}
.label {
  display: inline;
  font-size: 12px;
  font-weight: 500;
  line-height: 23px;
  color: rgba(166, 166, 166, 1);
}
.value {
  display: inline;
  font-size: 12px;
  font-weight: 600;
  line-height: 23px;
  color: rgba(59, 59, 59, 1);
  // white-space:nowrap;
  // overflow:hidden;
  // text-overflow:ellipsis;
}
</style>
